import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import './app/App.scss';
import {MaterialUIControllerProvider} from "./context";
import {Provider} from "./lib/AppContext";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {CompanyProvider} from "./lib/CompanyContext";
import {KioskViewProvider} from "./lib/KioskModeProvider";
import theme from "./assets/theme";
import {ThemeProvider} from "@mui/material/styles";
import {AccessProvider} from "./lib/AccessProvider";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <Provider>
            <CompanyProvider>
              <AccessProvider>
                <KioskViewProvider>
                  <App/>
                </KioskViewProvider>
              </AccessProvider>
            </CompanyProvider>
          </Provider>
        </ThemeProvider>
      </LocalizationProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
